// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"82a1b43f","635":"586a177c"}[chunkId] + ".chunk.js";
};